export default (api) => {
  api.news = {
    public: {
      read: (id = {}) => api.request({
        url: `/api/news/read/${id}`,
        type: 'get',
        tokenTypeLimit: 'member',
      }),
      index: (params = {}) => api.request({
        url: `/api/news/index`,
        type: 'get',
        params: {
          per: 4,
          ...params,
          sort: {
            created_at: 'desc',
          },
        },
      }),
      indexByType: (customParams) => {
        let deaultParams = {
          per: 4,
          sort: {
            created_at: 'desc',
          },
        }
        let params = {
          ...deaultParams,
          ...customParams
        }
        return api.request({
          url: `/api/news/index`,
          type: 'get',
          params,
        })
      },
      // 各節新聞
      series: () => api.request({
        url: `/api/news/series`,
        type: 'get',
      }),
      relational: (id) => api.request({
        url: `/api/news/relational/${id}`,
        type: 'get',
      }),
    },
    admin: {
      index: (params = null) => api.request({
        url: `/api/admin/news/index`,
        type: 'get',
        params,
      }),
      read: (id) => api.request({
        url: `/api/admin/news/${id}`,
        type: 'get',
      }),
      create: (params = {}) => api.request({
        url: `/api/admin/news`,
        type: 'post',
        params,
      }),
      updateAll: (id, params = {}) => api.request({
        url: `/api/admin/news/${id}/all`,
        type: 'put',
        params,
      }),
      update: (id, params = {}) => api.request({
        url: `/api/admin/news/${id}/update`,
        type: 'put',
        params,
      }),
      batch: (params) => api.request({
        url: `/api/admin/news/batch`,
        type: 'put',
        params,
      }),
      delete: (id) => api.request({
        url: `/api/admin/news/${id}`,
        type: 'delete',
      }),
      batchDelete: (params) => api.request({
        url: `/api/admin/news/batch`,
        type: 'delete',
        params,
      }),
      sync: () => api.request({
        url: `/api/admin/news/sync`,
        type: 'post',
      }),
    },
  }
}